import Api from "../api";
let uri = "/api/ed/busqueda/";

export const getResultadosBusqueda = async () => {
  try {
    const resp = await Api.getInstance().executeGetQuery(`${uri}`);
    return resp.data;
  } catch (error) {
    throw error;
  }
};
